export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8442.8c0e7a3c.jpg";